// extracted by mini-css-extract-plugin
module.exports = {"open-source":"_25nZ9F_zDBd5XbTUtEyZnm","openSource":"_25nZ9F_zDBd5XbTUtEyZnm"};